module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter1"
    }
  }, [_c('h1', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('a', {
    attrs: {
      "href": "#/005toc#ch1"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_vm._v("CHICKEN QUESADILLAS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This is a fast way to make quesadillas for a crowd because several can be made at one time by using this broiling method. Chopped chicken, salsa, and cheese make the filling. Use salsa of your choice, purchased or homemade. Serve with the cooling Creamy Avocado Dip.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-space1"
  }, [_vm._v("8 flour tortillas (10-inch)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" cup Fresh Tomato Salsa  or purchased salsa, plus extra for serving")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 cups diced cooked chicken breast")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("8 green onions including some tender green tops, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("4")]), _vm._v(" cup chopped fresh cilantro or parsley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1"), _c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" to 2 cups (6 to 8 ounces) grated Monterey Jack or Cheddar cheese")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Creamy Avocado Dip , for serving")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_vm._v("Preheat the broiler. Lay the tortillas on a flat surface. Spread about 1 tablespoon salsa on one half of each tortilla. Add some chicken, onions, cilantro, and cheese on top. Fold the other halves over and press down to enclose. Place the filled tortillas on a foil-lined broiler pan. Broil until the tortillas begin to brown, about 1 minute. Turn over and broil the other sides until lightly browned, about 40 seconds. Cut each tortilla in half and serve.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_vm._v("Makes 16 wedges")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_c('span', {
    staticClass: "yellow"
  }, [_c('strong', [_vm._v("NOTE:")])]), _vm._v(" These quesadillas can also be baked in a 400°F oven for about 6 minutes.")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('strong', [_vm._v("FRESH TOMATO SALSA")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Salsa appears on the Mexican table for every meal, to be served with almost any dish. You can make it as “hot” as you like by varying the amount of chiles that you use. It is best eaten the same day it’s prepared.")]), _vm._v(" "), _c('p', {
    staticClass: "hang-space1"
  }, [_vm._v("4 medium tomatoes, seeded, chopped, and drained")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("4")]), _vm._v(" cup diced white onion or chopped green onions including some tender green tops")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("4")]), _vm._v(" cup chopped fresh cilantro or parsley")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 tablespoon fresh lime juice")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 tablespoon olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 tablespoon chopped fresh oregano or "), _c('sup', {
    staticClass: "frac"
  }, [_vm._v("3")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("4")]), _vm._v(" teaspoon dried oregano")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 garlic cloves, minced")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 teaspoon minced jalapeño pepper or more to taste")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Freshly ground pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_vm._v("In a medium bowl, stir together all the ingredients, adding pepper to taste. Cover and let stand at room temperature at least 1 hour to allow flavors to blend, then cover and refrigerate until ready to use. Drain, if necessary, before using.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_vm._v("Makes about 3 cups")]), _vm._v(" "), _c('h4', [_c('strong', [_vm._v("CREAMY AVOCADO DIP")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 large ripe avocados, peeled, pitted, and mashed")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("4")]), _vm._v(" cup sour cream")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 tablespoon fresh lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("4")]), _vm._v(" teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("4")]), _vm._v(" teaspoon Worcestershire sauce")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("1 or 2 drops Tabasco sauce")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_vm._v("In a medium bowl, mix together all the ingredients.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-space1"
  }, [_vm._v("Makes about 1"), _c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")]), _vm._v("/"), _c('sub', {
    staticClass: "frac"
  }, [_vm._v("2")]), _vm._v(" cups")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ecc896e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/009-chapter1.vue
// module id = 81
// module chunks = 0